<adapt-universal-dashboard-element name="Meeting guidance"
                                   [disableClick]="(canEditTeamGuidance$ | async) === false"
                                   (headerClicked)="editTeamMeetingGuidance()"
                                   linkText="Define the meeting guidance"
                                   [contentCard]="isAlto"
                                   [isCollapsible]="isCollapsible"
                                   [collapsed]="true">
    <button *adaptIfAuthorised="editTeamKanban;Entity:team$ | async"
            adapt-header-action-right
            type="button"
            adaptButton="editLink"
            adaptTooltip="Edit team meeting guidance"
            adaptStopPropagation
            (click)="editTeamMeetingGuidance()"></button>

    <div *adaptLoadingUntilFirstEmit="let teamMeetingGuidance of teamMeetingGuidance$">
        @if (teamMeetingGuidance && teamMeetingGuidance?.containsGuidance) {
            <div class="d-flex flex-column gap-3">
                @if (teamMeetingGuidance.meetingIntent) {
                    <div>
                        <h4 class="mb-0">Why do we meet?</h4>
                        <div [froalaView]="teamMeetingGuidance.meetingIntent"></div>
                    </div>
                }

                @if (teamMeetingGuidance.meetingGuidelines) {
                    <div>
                        <h4 class="mb-0">How will we behave when we meet?</h4>
                        <div [froalaView]="teamMeetingGuidance.meetingGuidelines"></div>
                    </div>
                }

                @if (teamMeetingGuidance.meetingFrequency) {
                    <div>
                        <h4 class="mb-0">How frequently will we meet?</h4>
                        <div [froalaView]="teamMeetingGuidance.meetingFrequency"></div>
                    </div>
                }

                @if (teamMeetingGuidance.decisionProcess) {
                    <div>
                        <h4 class="mb-0">How will we make decisions?</h4>
                        <div [froalaView]="teamMeetingGuidance.decisionProcess"></div>
                    </div>
                }
            </div>
        } @else {
            <adapt-call-to-action-inline>
                <p>Setting your team's meeting guidance allows the team to define:</p>
                <ul class="list-content">
                    <li>The purpose for team meetings</li>
                    <li>The expected behaviour during team meetings</li>
                    <li>How frequently the team meets</li>
                    <li>The decision-making process</li>
                </ul>
                @if (!isAlto && !embedded) {
                    <button adaptCallToActionButton
                            adaptButtonIcon="edit"
                            *adaptIfAuthorised="editTeamKanban; entity: team$ | async"
                            (click)="editTeamMeetingGuidance()">Define the meeting guidance</button>
                }
            </adapt-call-to-action-inline>
        }
    </div>
</adapt-universal-dashboard-element>
